<div *ngIf="showSection" class="sts-body row">
  <div class="col-24">
    <div app-sts-cms-txt key="{{key}}" (renderingComplete)="renderingComplete.emit(true)">
      <ng-content></ng-content>
      <p>
        <span [innerHtml]="Content | stsSafeHtml"></span>
        <span *ngIf="showRegLink" >
          <span [innerHtml]="regPrefix | stsSafeHtml"></span>
          <a
             routerLink="/account/reg-step-1" [ngStyle]="styles">{{regTitle}}</a>
          <span [innerHtml]="regSuffix | stsSafeHtml"></span>
        </span>
      </p>
    </div>
  </div>
</div>
